/* eslint-disable eqeqeq */
import BackendLayout from "../../layouts/BackendLayout";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {UPDATE_INSPECTION} from "../../constants/routes";
import {getUpdateInspectionPageSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import StepBar from "../../components/StepBar";
import {useDocumentTitle, useTableInspectionItemsScroll} from "../../hooks";
import CalendarIcon from "../../assets/icons/calendar-big-icon.svg";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import SettingIcon from "../../assets/icons/setting-big-icon.svg";
import VerifiedUserIcon from "../../assets/icons/verified-user-icon.svg";
import InputLabel from "../../components/InputLabel";
import CustomImg from "../../components/CustomImg";
import {PageTitle} from "../../components/admin";
import CustomSpan from "../../components/CustomSpan";
import Select2 from "../../components/Select2";
import {
  TextInput,
  Label,
  CheckboxInput,
  FormGroupInput,
  RemarkDetail,
  DatetimePicker,
  ButtonBack,
  Button,
  ButtonDPad,
  JudgmentLimit, RedirectAlert
} from "../../components";
import {hasErrorInput, errorStatusHandle, getFileIdsFromEditor} from "../../utils";
import {getSelectedValue, formatUserOptions, convertToOptions} from "../../utils/select-utils";
import Table from "../../components/table/Table";
import {useParams, useNavigate} from "react-router-dom";
import {
  getInformationInspection,
  update,
  changeMachineSelect,
  changeMachineInput
} from "../../services/inspection/UpdateInspection"
import {formatDate, formatDateTime} from "../../utils/datetime-utils";
import store from "../../store";
import {HTTP_ERROR_CODES} from "../../constants/error";
import {
  setRegisterInspectionAlertError,
  resetAlert,
  setAlertSuccess,
  setButtonProcessing,
  clearButtonProcessing
} from "../../store/actions";
import PageAlert from '../../components/alerts/PageAlert';
import {MACHINE_INPUT} from "../../constants/routes";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {LiaEditSolid} from "react-icons/lia";
import {smoothScrollToTop} from "../../utils/common-utils";
import {
  clearPageLoading,
  setPageLoading
} from '../../store/actions';
import {
  BUTTON_UPDATE_INSPECTION,
} from "../../constants/buttons";
import TextEditor from "../../components/form/inputs/TextEditor";
import {
  getBackgroundSymbol,
  getInspectionUnit,
  formatUserDisplay
} from "../../utils/display-utils";
import {INSPECTION_ITEM_JUDGMENT_INPUT_TYPE} from "../../constants/app";
import ToolIcon from "../../assets/icons/inspection-number-icon.svg";
import TooltipComment from "../../components/TooltipComment"
import {UPDATE_INSPECTION_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function UpdateInspectionPage() {
  useRedirectPage(UPDATE_INSPECTION_PAGE);
  const stepBarItems = [
    {spanText: '設備入力', hasPassed: true},
    {spanText: '点検結果登録', isActive: true, isBack: true}
  ];
  const navigate = useNavigate();
  const {inspectionId} = useParams();
  const auth = store.getState().auth;
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const [inspectionMachine, setInspectionMachine] = useState([]);
  const [inspection, setInspection] = useState(null);
  const [managerUsers, setManagerUsers] = useState([]);
  const [inspectionItem, setInspectionItem] = useState([]);
  const [commentFiles, setCommentFiles] = useState([]);
  const [commentImagesThumb, setCommentImagesThumb] = useState([]);
  const [canEdit, setCanEdit] = useState(true);
  const [errorMessagesUpdate, setErrorMessagesUpdate] = useState({});
  const [formUpdate, setFormUpdate] = useState({});
  const resultField = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const inspectionSettings = useSelector((s) => s.app_settings.inspection);
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const maxHeightTable = useTableInspectionItemsScroll(tableRef, inspectionItem);
  
  const [correctionUserOptions, setCorrectionUserOptions] = useState([{
    value: auth.user.id,
    label: formatUserDisplay(auth.user)
  }]);

  useEffect(() => {
    const successMessage  = localStorage.getItem('successMessageInspection');
    if (successMessage) {
      dispatch(setAlertSuccess(successMessage));
      localStorage.removeItem('successMessageInspection');
    }
    setUpdateInspectionPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inspectionId]);

  const handleInputChange = (key, value) => {
    setFormUpdate(prev => ({
      ...prev,
      [key]: value
    }))
  };

  const breadcrumb = getPageBreadcrumb(UPDATE_INSPECTION);
  const setUpdateInspectionPageSettings = async () => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getUpdateInspectionPageSettings();
      dispatch(setPageSettings(pageSettings));

      const informationInspection = await getInformationInspection(inspectionId);
      const listInspection = informationInspection.data.inspection.result_inspection;
      const inspection = informationInspection.data.inspection;
      let correction_registration_datetime = pageSettings.datetime;
      let correction_user_id = auth.user.id;
      if (!informationInspection.data.can_edit) {
        correction_registration_datetime = inspection['correction_registration_datetime'] ? formatDateTime(new Date(inspection['correction_registration_datetime'])) : '';
        correction_user_id = inspection['correction_user'] ? inspection['correction_user'].id : '';
        if (inspection['correction_user']) {
          setCorrectionUserOptions([{
            value: inspection['correction_user'].id,
            label: formatUserDisplay(inspection['correction_user'])
          }])
        }
      }

      setInspection(inspection);
      formUpdate['correction_registration_datetime'] = correction_registration_datetime;
      formUpdate['correction_user_id'] = correction_user_id;
      formUpdate['execution_date'] = formatDate(new Date(inspection['execution_date']));
      formUpdate['execution_user_id'] = inspection.execution_user.id;
      formUpdate['machine_id'] = inspection['machine']['id'];
      formUpdate['has_inspected'] = inspection['result'] !== -1;
      formUpdate['machine'] = inspection['machine']['name'];

      setInspection(inspection);
      setCanEdit(informationInspection.data.can_edit);
      setInspectionItem(listInspection);
      setInspectionMachine(convertToOptions(informationInspection.data.inspection_machines));
      if (inspectionSettings?.machine_change_method_text === true) {
        setInspectionMachine(inspection['machine']['name']);
      }
      setManagerUsers(formatUserOptions(informationInspection.data.manager_users));

      const updatedformUpdate = Object.keys(resultField).reduce((acc, key) => {
        if (key.toLowerCase().includes("datetime")) {
          acc[key] = inspection[key] ? formatDateTime(new Date(inspection[key])) : inspection[key];
        } else {
          acc[key] = inspection[key];
        }
        return acc
      }, {...formUpdate});

      const updatedForm = listInspection.reduce((acc, item, index) => {
        acc[`inspection_item_${item.inspection_item.id}`] = item.inspection_item_value;
        return acc;
      }, {...updatedformUpdate});
      setFormUpdate(updatedForm);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const firstInputIndex = inspectionItem.findIndex(item => item.inspection_item.inspection_item_type.name === 'input');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setButtonProcessing(BUTTON_UPDATE_INSPECTION));
    try {
      const formData = new FormData();
      Object.keys(formUpdate).forEach(key => {
        if (formUpdate[key] !== null) {
          formData.append(key, formUpdate[key])
        } else {
          formData.append(key, '')
        }
      });

      if (formUpdate?.remark_text) {
        const fileIdsInEditor = getFileIdsFromEditor(formUpdate.remark_text);
        const filteredFiles = commentFiles.filter(file => fileIdsInEditor.includes(file.id));
        const filteredImagesThumb =  commentImagesThumb.filter(file => fileIdsInEditor.includes(file.id));

        filteredFiles.forEach((file) => {
          formData.append('comment_file_ids', file.id);
          formData.append('comment_files', file.file);
        });

        filteredImagesThumb.forEach((file) => {
          formData.append('comment_images_thumb', file.file);
          formData.append('comment_image_thumb_ids', file.id);
        });

        fileIdsInEditor.forEach((id) => {
          formData.append('all_comment_file_ids', id);
        });
      }

      const response = await update(inspectionId, formData);
      dispatch(setAlertSuccess(response.message));
      setErrorMessagesUpdate([]);
      smoothScrollToTop();
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesUpdate(responseData.errors)
      }
      smoothScrollToTop();
    } finally {
      dispatch(clearButtonProcessing(BUTTON_UPDATE_INSPECTION));
    }
  };

  const handleSelectChange = (selectOption, name) => {
    var value = '';
    if (selectOption) {
      value = selectOption.value
    }

    setFormUpdate({
      ...formUpdate,
      [name]: value
    })
  };

  const handleMachineChangeInput = async (e) => {
    if (e.key === 'Enter') {
      try {
        const formData = new FormData();
        formData.append('machine', formUpdate['machine']);
        const response = await changeMachineInput(inspectionId, formData);
        dispatch(resetAlert());
        navigate(response.nextUrl);
        setErrorMessagesUpdate([]);
      } catch (e) {
        errorStatusHandle(e);
        if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
          let responseData = e.data;
          dispatch(setRegisterInspectionAlertError(responseData));
          setErrorMessagesUpdate(responseData.errors)
        }
      }
    }
  };

  const handleMachineChangeSelect = async (machineId) => {
    try {
      const response = await changeMachineSelect(inspectionId, {'machine_id': machineId});
      dispatch(resetAlert());
      navigate(response.nextUrl);
      setErrorMessagesUpdate([]);
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === HTTP_ERROR_CODES.BAD_REQUEST) {
        let responseData = e.data;
        dispatch(setRegisterInspectionAlertError(responseData));
        setErrorMessagesUpdate(responseData.errors)
      }
    }
  };

  const handleButtonBack = () => {
    dispatch(resetAlert());
    setErrorMessagesUpdate([]);
    return navigate(MACHINE_INPUT);
  };

  const handleCheckBoxChange = (key, value) => {
    setFormUpdate(prev => {
      const newFormUpdate = {...prev};
      if (newFormUpdate[key] === value) {
        newFormUpdate[key] = '';
      } else {
        newFormUpdate[key] = value;
      }
      return newFormUpdate;
    });
  };

  const handleCheckInspected = () => {
    setFormUpdate(prev => {
      const newFormUpdate = {...prev};
      inspectionItem.forEach(item => {
        const key = `inspection_item_${item.inspection_item.id}`;
        if (key in newFormUpdate) {
          newFormUpdate[key] = '';
        }
      });
      if (prev.has_inspected) {
        newFormUpdate['operation_start_datetime'] = '';
        newFormUpdate['operation_start_user_id'] = '';
      }
      newFormUpdate.has_inspected = !prev.has_inspected;
      return newFormUpdate
    });
    setErrorMessagesUpdate([]);
    dispatch(resetAlert());
  };

  useDocumentTitle("点検結果登録 - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <StepBar stepBarItems={stepBarItems}/>
      <PageTitle title="点検結果登録"/>
      <ButtonDPad/>
      <div className="inline-block mr-[24px] mt-4">
        <div className="w-full flex flex-col justify-start xl:gap-[16px] gap-[16px] flex-1">
          <RedirectAlert className="!mb-0"/>
          <PageAlert className="!mb-0"/>
          <div className="flex items-center 2xl:gap-[60px] xl:gap-[16px] tenken__text-gray-900 lg:gap-[12px] gap-[8px]"
               id="scroll_top">
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border w-fit border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="実施日" className="w-[140px] tenken__text-gray-900" htmlFor="execution_date"/>
                <Label name="execution_date"
                       className="tenken__text-gray-900 xl:py-[6px] py-[4px] xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                       id="execution_date"
                       text={formatDate(formUpdate['execution_date'])}/>
              </div>
              <CustomImg src={CalendarIcon} alt="Calendar Icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="設備No." className="w-[140px] tenken__text-gray-900" htmlFor="machine_no"/>
                {inspectionSettings?.machine_change_method_select === true && (
                  <Select2 name="machine_no"
                           options={inspectionMachine}
                           classNamePrefix="react-select"
                           className="tenken__text-gray-900 xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                           id="machine_no"
                           placeholder=""
                           maxLength={200}
                           widthMenu="180px"
                           onChange={(inspectionMachine) => handleMachineChangeSelect(inspectionMachine.value)}
                           value={getSelectedValue(inspectionMachine, formUpdate['machine_id'])}
                           hasError={hasErrorInput(errorMessagesUpdate, 'machine_id')}
                  />
                )}
                {inspectionSettings?.machine_change_method_text === true && (
                  <TextInput
                    className="tenken__text-gray-900 xl:text-[16px] text-[15px] 2xl:w-[180px] w-[155px]"
                    name="machine" autoFocus
                    id="machine"
                    maxLength={200}
                    nextFocus={false}
                    readOnly={!canEdit}
                    disabled={!canEdit}
                    value={formUpdate['machine']}
                    onKeyPress={handleMachineChangeInput}
                    onChange={(e) => handleInputChange(`machine`, e.target.value)}
                    hasError={hasErrorInput(errorMessagesUpdate, 'machine')}
                  />
                )}
              </div>
              <CustomImg src={SettingIcon} alt="Setting Icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="点検テンプレート名" className="tenken__text-gray-900" htmlFor="template"/>
                <Label name="template"
                       className="xl:py-[6px] py-[4px] tenken__text-gray-900 xl:text-[16px] text-[15px] truncate 2xl:w-[220px] xl:w-[200px] w-[175px]"
                       id="template"
                       title={inspection?.template?.name || ''}
                       text={inspection?.template?.name || ''}/>
              </div>
              <CustomImg src={PageEditIcon} alt="User icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] w-fit border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="ユーザー" className="w-[140px] tenken__text-gray-900" htmlFor="user"/>
                <Label name="user"
                       className="tenken__text-gray-900 xl:text-[16px] text-[15px] py-[4px] truncate 2xl:w-[220px] xl:w-[200px] w-[175px]"
                       id="user"
                       title={inspection?.execution_user ? formatUserDisplay(inspection.execution_user) : ''}
                       text={inspection?.execution_user ? formatUserDisplay(inspection.execution_user) : ''}/>
              </div>
              <CustomImg src={VerifiedUserIcon} alt="User icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
            <div
              className="flex items-center 2xl:px-[16px] 2xl:py-[10px] px-[12px] py-[8px] w-fit border border-[#E0E0E0] bg-white rounded-lg 2xl:gap-[20px] xl:gap-[12px] gap-[10px] 2xl:h-[92px] lg:h-[88px] h-[81px]">
              <div className="flex flex-col">
                <Label text="点検回数" className="min-w-[100px] tenken__text-gray-900" htmlFor="inspection_number"/>
                <Label name="inspection_number"
                       className="tenken__text-gray-900 xl:text-[16px] text-[15px] py-[4px]"
                       id="inspection_number"
                       text={`${inspection?.inspection_number}回目`}/>

              </div>
              <CustomImg src={ToolIcon} alt="Tool icon"
                         className="2xl:max-w-[48px] 2xl:h-[48px] xl:max-w-[40px] xl:h-[40px] max-w-[36px] h-[36px]"></CustomImg>
            </div>
          </div>
          <div className="flex flex-col flex-start w-full max-w-[1674px] min-w-[1120px] xl:gap-[24px] gap-[18px]">
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-between items-center self-stretch">
                <CustomSpan text="点検結果を入力してください" className="lg:text-[16px] text-[15px] tenken__text-gray-900"/>
                <div className="flex justify-end items-center">
                  <CheckboxInput name="has_inspected" id="has_inspected"
                                 checked={!formUpdate['has_inspected']}
                                 disabled={!canEdit}
                                 onChange={handleCheckInspected}
                                 label="設備が停止中のため点検しない" classLabel="lg:text-[16px] text-[15px] tenken__text-gray-900">
                  </CheckboxInput>
                </div>
              </div>
              <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                maxHeight: maxHeightTable ? `${maxHeightTable}px` : "auto"
              }} ref={tableRef}>
                <Table className="no-drop-shadow-table" striped>
                  <Table.Head className={`${maxHeightTable ? 'sticky top-0 z-[8]' : ''}`}>
                    <Table.HeadCell
                      className="!normal-case w-[76px]"
                    >
                      <span>No.</span>
                    </Table.HeadCell>
                    <Table.HeadCell
                    >
                      <span className="whitespace-nowrap">点検項目</span>
                    </Table.HeadCell>
                    <Table.HeadCell
                    >
                      <span className="whitespace-nowrap">判定基準</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="inline-block min-w-[40px] whitespace-nowrap">下限</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                      <span className="inline-block min-w-[40px] whitespace-nowrap">上限</span>
                    </Table.HeadCell>
                    <Table.HeadCell>
                    </Table.HeadCell>
                    <Table.HeadCell
                    >
                      <span className="whitespace-nowrap">留意事項</span>
                    </Table.HeadCell>
                    <Table.HeadCell className="2xl:w-[320px] xl:w-[240px] w-[200px]">
                      <span className="whitespace-nowrap">点検結果</span>
                    </Table.HeadCell>
                  </Table.Head>
                  <Table.Body className="devide-y text-base">
                    {inspectionItem && inspectionItem.length > 0 ? (
                      inspectionItem.map((item, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>
                            <span>{index + 1}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[400px]">
                          <span
                            className="break-all"
                            style={{color: item.inspection_item.title_color}}>{item.inspection_item.title}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                          <span
                            className="break-all"
                            style={{color: item.inspection_item.description_color}}>{item.inspection_item.description}</span>
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_item?.inspection_judgment?.lower_value}
                              boundaryType={item.inspection_item?.inspection_judgment?.lower_boundary_type}
                              unit={item.inspection_item?.unit}
                              type="lower"
                            />
                          </Table.Cell>
                          <Table.Cell className="max-w-[300px]">
                            <JudgmentLimit
                              value={item.inspection_item?.inspection_judgment?.upper_value}
                              boundaryType={item.inspection_item?.inspection_judgment?.upper_boundary_type}
                              unit={item.inspection_item?.unit}
                              type="upper"
                            />
                          </Table.Cell>
                          <Table.Cell>
                          <span
                            title={item.inspection_item?.unit}
                            className="whitespace-nowrap"
                          >
                            {item.inspection_item?.unit ? getInspectionUnit(item.inspection_item?.unit, true) : "-"}
                          </span>
                          </Table.Cell>
                          <Table.Cell>
                            <RemarkDetail key={index} rowData={item.inspection_item}/>
                          </Table.Cell>
                          <Table.Cell>
                            {item.inspection_item?.inspection_item_type?.name === 'checkbox' && (
                              <div className="flex items-center 2xl:gap-[32px] xl:gap-[28px] gap-[24px]">
                                <CheckboxInput name={`inspection_item_${item.inspection_item.id}`}
                                               id={`inspection_item_OK_${item.inspection_item.id}`}
                                               checked={formUpdate[`inspection_item_${item.inspection_item.id}`] === 'OK'}
                                               disabled={!canEdit || !formUpdate['has_inspected']}
                                               value="OK"
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.inspection_item.id}`, 'OK')}
                                               label={resultSymbolSetting['passed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.passed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'passed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px] text-[#039855]">
                                </CheckboxInput>

                                <CheckboxInput name={`inspection_item_${item.inspection_item.id}`}
                                               id={`inspection_item_NG_${item.inspection_item.id}`}
                                               checked={formUpdate[`inspection_item_${item.inspection_item.id}`] === 'NG'}
                                               disabled={!canEdit || !formUpdate['has_inspected']}
                                               value="NG"
                                               onChange={() => handleCheckBoxChange(`inspection_item_${item.inspection_item.id}`, 'NG')}
                                               label={resultSymbolSetting['failed'].symbol}
                                               labelStyle={{
                                                 color: resultSymbolSetting.failed.color,
                                                 background: getBackgroundSymbol(resultSymbolSetting, 'failed')
                                               }}
                                               classLabel="xl:text-[20px] text-[18px]">
                                </CheckboxInput>
                              </div>
                            )}
                            {item.inspection_item?.inspection_item_type?.name === 'input' && (
                              <div className="flex">
                                <FormGroupInput className="items-center relative w-full">
                                  {getInspectionUnit(item.inspection_item.unit) !== "" ? (
                                    <>
                                      <TextInput name={`inspection_item_${item.inspection_item.id}`} type="text"
                                                 autoFocus={index === firstInputIndex}
                                                 onChange={(e) => handleInputChange(`inspection_item_${item.inspection_item.id}`, e.target.value)}
                                                 value={formUpdate[`inspection_item_${item.inspection_item.id}`] || ''}
                                                 hasError={hasErrorInput(errorMessagesUpdate, `inspection_item_${item.inspection_item.id}`)}
                                                 readOnly={!canEdit || !formUpdate['has_inspected']}
                                                 disabled={!canEdit || !formUpdate['has_inspected']}
                                                 className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:pl-[14px] 2xl:pr-[104px] 2xl:py-[10px] xl:pl-[12px] xl:pr-[96px] xl:py-[8px] pl-[10px] pr-[40px] py-[6px] rounded-lg border border-[#D0D5DD]"
                                                 {...(item.inspection_item?.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                                   ? {maxLength: item.inspection_item?.inspection_judgment?.max_string_length}
                                                   : {}
                                                 }
                                      />
                                      <CustomSpan
                                        title={item.inspection_item.unit}
                                        className="absolute right-3 2xl:text-[16px] tenken__text-gray-900 xl:text-[15px] text-[14px]"
                                      >
                                        {getInspectionUnit(item.inspection_item.unit)}
                                      </CustomSpan>
                                    </>
                                  ) : (
                                    <>
                                       <TextInput name={`inspection_item_${item.inspection_item.id}`} type="text"
                                                 autoFocus={index === firstInputIndex}
                                                 onChange={(e) => handleInputChange(`inspection_item_${item.inspection_item.id}`, e.target.value)}
                                                 value={formUpdate[`inspection_item_${item.inspection_item.id}`] || ''}
                                                 hasError={hasErrorInput(errorMessagesUpdate, `inspection_item_${item.inspection_item.id}`)}
                                                 readOnly={!canEdit || !formUpdate['has_inspected']}
                                                 disabled={!canEdit || !formUpdate['has_inspected']}
                                                 className="w-full tenken__text-gray-900 min-w-[200px] max-w-[280px] focus:ring-0 focus:border-[#D0D5DD] bg-white 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] px-[10px] py-[6px] rounded-lg border border-[#D0D5DD]"
                                                 {...(item.inspection_item?.inspection_judgment?.input_value_type === INSPECTION_ITEM_JUDGMENT_INPUT_TYPE.TEXT)
                                                   ? {maxLength: item.inspection_item?.inspection_judgment?.max_string_length}
                                                   : {}
                                                 }
                                      />
                                    </>
                                  )}
                                </FormGroupInput>
                              </div>
                            )}
                          </Table.Cell>
                        </Table.Row>
                      ))
                    ) : (
                      null
                    )}
                  </Table.Body>
                </Table>
              </div>
            </div>

            <div className="relative rounded-lg border border-[#e0e0e0]">
              <Table className="no-drop-shadow-table" striped>
                <Table.Head className="whitespace-nowrap">
                  <Table.HeadCell
                    className="w-[43%]"
                  >
                    <span>点検者情報を入力・確認してください</span>
                  </Table.HeadCell>
                  <Table.HeadCell
                  >
                  </Table.HeadCell>
                </Table.Head>
                <Table.Body className="devide-y text-base whitespace-nowrap">
                  {resultField && Object.keys(resultField).length > 0 ? (
                    Object.entries(resultField).map(([key, value], index) => (
                      <Table.Row key={index}>
                        <Table.Cell>
                          <span className="tenken__text-gray-900">{value}</span>
                        </Table.Cell>
                        <Table.Cell>
                          <FormGroupInput className="!flex-col">
                            <FormGroupInput className="gap-[20px]">
                              {key == 'inspection_start_user_id' || key == 'operation_start_user_id' ? (
                                <Select2
                                  options={managerUsers}
                                  className="xl:text-base text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] w-[260px] tenken__text-gray-900"
                                  classNamePrefix="react-select"
                                  maxLength={20}
                                  onChange={(managerUsers) => handleSelectChange(managerUsers, key)}
                                  value={getSelectedValue(managerUsers, formUpdate[key] || (key == 'operation_start_user_id' ? '' : auth.user.id))}
                                  placeholder=''
                                  name={key}
                                  isClearable={key == 'operation_start_user_id' ? true : false}
                                  isDisabled={(!canEdit) || (key == 'operation_start_user_id' && !formUpdate['has_inspected'])}
                                  hasError={hasErrorInput(errorMessagesUpdate, key)}
                                />
                              ) : (
                                <DatetimePicker name={key}
                                                id={`operation_start_datetime_${key}`}
                                                onChange={handleInputChange}
                                                value={formUpdate[key]}
                                                disabled={(!canEdit) || (key == 'operation_start_datetime' && !formUpdate['has_inspected'])}
                                                showClearButton={key == 'operation_start_datetime' ? true : false}
                                                maxLength={16}
                                                hasError={hasErrorInput(errorMessagesUpdate, key)}
                                                className="tenken__text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] w-[260px] 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] px-[10px] py-[6px] rounded-lg border border-[#D0D5DD] focus:ring-0 focus:border-[#D0D5DD]">
                                </DatetimePicker>
                              )}
                            </FormGroupInput>
                          </FormGroupInput>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  ) : (
                    null
                  )}
                  {formUpdate['correction_registration_datetime'] !== '' && (
                    <Table.Row>
                      <Table.Cell>
                        <span className="tenken__text-gray-900">修正作業日時</span>
                      </Table.Cell>
                      <Table.Cell>
                        <FormGroupInput className="!flex-col">
                          <FormGroupInput className="gap-[20px]">
                            <DatetimePicker name="correction_registration_datetime"
                                            id='correction_registration_datetime'
                                            onChange={handleInputChange}
                                            maxLength={16}
                                            disabled={(!canEdit)}
                                            value={formUpdate['correction_registration_datetime']}
                                            hasError={hasErrorInput(errorMessagesUpdate, 'correction_registration_datetime')}
                                            className="tenken__text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] 2xl:px-[14px] 2xl:py-[10px] xl:px-[12px] xl:py-[8px] md:px-[10px] md:py-[6px] rounded-lg border border-[#D0D5DD] focus:ring-0 focus:border-[#D0D5DD]">
                            </DatetimePicker>
                          </FormGroupInput>
                        </FormGroupInput>
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {formUpdate['correction_user_id'] !== '' && (
                    <Table.Row>
                      <Table.Cell>
                        <span className="tenken__text-gray-900">修正作業者</span>
                      </Table.Cell>
                      <Table.Cell>
                        <FormGroupInput className="!flex-col">
                          <FormGroupInput className="gap-[20px]">
                            <Select2
                              options={correctionUserOptions}
                              className="xl:text-base text-gray-900 2xl:w-[320px] xl:w-[300px] lg:w-[280px] md:w-[260px] tenken__text-gray-900"
                              classNamePrefix="react-select"
                              maxLength={20}
                              isDisabled={(!canEdit)}
                              onChange={(correctionUserOptions) => handleSelectChange(correctionUserOptions, 'correction_user_id')}
                              value={getSelectedValue(correctionUserOptions, formUpdate['correction_user_id'])}
                              placeholder=''
                              name="correction_user_id"
                              hasError={hasErrorInput(correctionUserOptions, 'correction_user_id')}
                            />
                          </FormGroupInput>
                        </FormGroupInput>
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            </div>
            <div
              className="flex flex-col 2xl:p-[24px] xl:p-[16px] p-[12px] bg-[#FFF] justify-center item-center rounded-lg w-full xl:gap-[20px] gap-[12px] border border-[#e0e0e0]">
              <div className="flex items-center">
                <InputLabel className="font-medium lg:text-[16px] text-[15px]" text="点検コメント"/>
                <TooltipComment isDisplay={canEdit}/>
              </div>
              <TextEditor
                onChange={handleInputChange}
                name="remark_text"
                remarkText={inspection?.remark_text}
                commentFiles={inspection?.inspection_comment_files}
                canEdit={canEdit}
                setCommentImagesThumb={setCommentImagesThumb}
                setCommentFiles={setCommentFiles}
              />
            </div>
            <div className="flex items-center py-[10px] 2xl:gap-[120px] xl:gap-[100px] gap-[80px] justify-center"
                 id="scroll_bottom">
              <ButtonBack onClick={() => handleButtonBack()}/>
              <Button type="submit" theme={tenkenTheme.button} color="primary" onClick={(e) => handleSubmit(e)}
                      disabled={!canEdit}
                      id={BUTTON_UPDATE_INSPECTION} className="rounded-lg border min-w-[280px]">
                <LiaEditSolid className="text-white font-medium mr-[2px]" size={20}/>
                変更
              </Button>
            </div>
          </div>
        </div>
      </div>
    </BackendLayout>
  )
}